import React from 'react';
import { IconSvgProps } from '@models/common';

const Rescan: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.9999 20.9999L16.6499 16.6499'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3 19L8 19L8 18.4185M10 3.06189C6.05369 3.55399 3 6.92038 3 11C3 14.3574 5.06817 17.2317 8 18.4185M8 18.4185L8 14M19 3L14 3L14 3.58152M14 3.58152C16.9318 4.76829 19 7.64262 19 11C19 15.0796 15.9463 18.446 12 18.9381M14 3.58152L14 8'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Rescan;
